/**
 * Kill-app mid-Preparar: meta incompleta y ya subió todo lo declarado.
 * n === meta (no >=): si n > meta es anomalía de conteo, no «falta preparar».
 */
export function esPrepFotosCortada(elegF, metaN, n) {
  const e = Number(elegF) || 0;
  const m = Number(metaN) || 0;
  const subidas = Number(n) || 0;
  return e > 0 && m > 0 && m < e && subidas === m && subidas < e;
}

export function etiquetaFotosFaltaPreparar(n, elegF) {
  return `Fotos ${n}/${elegF} (falta preparar)`;
}
